import AppTooltip from "elements/AppTooltip";
import { Button, Badge } from "reactstrap";
import { callFunctionIfExists } from "utils/GeneralUtils";

const WarningBadge = () => {
  return (
    <i
      className="mdi mdi-alert text-dark"
      style={{
        position: "absolute",
        top: "0.25rem",
        right: "2rem",
        fontSize: 24,
      }}
    />
  );
};

const IconCard = ({
  icon, // Example: mdi mdi-icon
  type,
  name,
  description,
  isTrigger,
  optionsMenu,
  isSelected,
  isDisabled,
  onClick,
  width = "100%",
  maxWidth = "unset",
  css,
  index = null,
  tooltip = null,
  useDragHandle = null,
  vectorIcon = false,
  errors,
  iconOutline = true,
}) => {
  if (!tooltip && errors) {
    tooltip = errors.join(", ");
  }

  const IconCardBadge = (
    <Badge
      style={{
        position: "absolute",
        padding: "4px 7px 3px 7px",
        fontSize: 15,
        top: -10,
        left: -10,
        cursor: "pointer",
        borderRadius: 8,
      }}
      className="px-2 cursor-pointer py-1 text-dark bg-primary-selected border border-primary"
    >
      {index}
    </Badge>
  );

  const DragHandle = () => {
    return (
      <i
        className="mdi mdi-drag"
        style={{ fontSize: 24, cursor: "grab" }}
        {...useDragHandle.listeners}
        {...useDragHandle.attributes}
      />
    );
  };

  const Content = (
    <div
      style={{ width, maxWidth }}
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation();
              callFunctionIfExists(onClick);
            }
          : null
      }
      className={css || ""}
    >
      <div
        className="workflow-action-card w-100 rounded shadow-sm shadow--hover d-flex px-2 pt-3 pb-3 align-items-center cursor-pointer"
        style={{
          outline: isSelected
            ? "1px solid var(--dropdown-selected-dark)"
            : errors
            ? "2px solid var(--danger)"
            : "1px solid var(--superlight)",
          background: isSelected
            ? "var(--dropdown-selected)"
            : isDisabled
            ? "var(--superlight)"
            : errors
            ? "#ffa8a8"
            : "white",
          position: "relative",
        }}
      >
        {errors && <WarningBadge />}
        <div className="drag-handle">{useDragHandle && <DragHandle />}</div>
        <div>{!isTrigger && index !== null && IconCardBadge}</div>
        {isTrigger && (
          <Badge
            style={{
              position: "absolute",
              padding: "4px 7px 3px 7px",
              fontSize: 15,
              top: -10,
              left: -10,
              zIndex: 2,
              cursor: "pointer",
              borderRadius: 8,
            }}
            className="px-1 cursor-pointer py-1 text-dark bg-primary-selected border border-primary"
          >
            <AppTooltip
              content={
                <>
                  This workflow process will start when this action is
                  triggered.
                </>
              }
              useTooltip
            >
              <i className="mdi mdi-lightning-bolt" />
            </AppTooltip>
          </Badge>
        )}
        <div
          className={`${
            iconOutline
              ? isSelected
                ? " border border-dropdown-selected-dark"
                : " border border-superlight"
              : ""
          } ml-2 mr-3 px-2 rounded-sm ${iconOutline ? "bg-white" : ""}`}
          style={{ position: "relative" }}
        >
          {vectorIcon ? (
            <>
              <div
                style={{
                  width: "calc(55px - 1rem)",
                  height: "calc(55px)",
                }}
                className="d-flex align-items-center"
              >
                <img
                  src={icon}
                  style={{
                    width: "100%",
                  }}
                  alt="ICON"
                ></img>
              </div>
            </>
          ) : (
            <i className={icon} style={{ fontSize: 36 }} />
          )}
        </div>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div>
            <h3 className="mb-0 pr-4">{name}</h3>
            <div className="pr-2" style={{ fontSize: 14 }}>
              {description}
            </div>
          </div>
          {optionsMenu && (
            <Button size="sm" outline className="px-2">
              Edit
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  return tooltip ? (
    <AppTooltip content={tooltip} useTooltip>
      {Content}
    </AppTooltip>
  ) : (
    Content
  );
};

export default IconCard;
